export const TaskboardLogo = ({ className = '' }: { className?: string }) => (
  <svg viewBox="0 0 200 120" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect
      x="10"
      y="10"
      width="50"
      height="100"
      fill="none"
      stroke="#4A90D9"
      strokeWidth="3"
      rx="5"
    />
    <rect x="20" y="30" width="30" height="15" fill="#E0E0E0" rx="3" />
    <rect x="20" y="50" width="30" height="15" fill="#E0E0E0" rx="3" />
    <rect x="20" y="70" width="30" height="15" fill="#E0E0E0" rx="3" />

    <rect
      x="75"
      y="10"
      width="50"
      height="100"
      fill="none"
      stroke="#4A90D9"
      strokeWidth="3"
      rx="5"
    />
    <rect x="85" y="30" width="30" height="15" fill="#4A90D9" rx="3" />
    <circle cx="112" cy="37" r="5" fill="#4A90D9" />
    <path d="M109 37 L111 39 L115 35" stroke="white" strokeWidth="1.5" fill="none" />
    <rect x="85" y="50" width="30" height="15" fill="#4A90D9" rx="3" />
    <circle cx="112" cy="57" r="5" fill="#4A90D9" />
    <path d="M109 57 L111 59 L115 55" stroke="white" strokeWidth="1.5" fill="none" />
    <rect x="85" y="70" width="30" height="15" fill="#E0E0E0" rx="3" />

    <rect
      x="140"
      y="10"
      width="50"
      height="100"
      fill="none"
      stroke="#4A90D9"
      strokeWidth="3"
      rx="5"
    />
    <rect x="150" y="30" width="30" height="15" fill="#7FB3E5" rx="3" />
    <circle cx="177" cy="37" r="5" fill="#7FB3E5" />
    <path d="M174 37 L176 39 L180 35" stroke="white" strokeWidth="1.5" fill="none" />
    <rect x="150" y="50" width="30" height="15" fill="#7FB3E5" rx="3" />
    <circle cx="177" cy="57" r="5" fill="#7FB3E5" />
    <path d="M174 57 L176 59 L180 55" stroke="white" strokeWidth="1.5" fill="none" />
    <rect x="150" y="70" width="30" height="15" fill="#7FB3E5" rx="3" />
    <circle cx="177" cy="77" r="5" fill="#7FB3E5" />
    <path d="M174 77 L176 79 L180 75" stroke="white" strokeWidth="1.5" fill="none" />
  </svg>
);
